import styled from '../styled-components';
export const SampleControls = styled.div.withConfig({
  componentId: "sc-1xh9cza-0"
})(["opacity:0.4;transition:opacity 0.3s ease;text-align:right;> span{display:inline-block;padding:2px 10px;cursor:pointer;:hover{background:rgba(255,255,255,0.1);}}"]);
export const SampleControlsWrap = styled.div.withConfig({
  componentId: "sc-1xh9cza-1"
})(["&:hover ", "{opacity:1;}"], SampleControls);